export class PluginBase {
  constructor(logger, driver, plugin, stream) {
    this.logger = logger;
    this.driver = driver;
    this.plugin = plugin;
    this.stream = stream;
  }

}